<template>
    <div class="auth-form">
        <div class="container pt-0">
            <form method="POST" v-on:submit.prevent="login" class="form-signin">
                <img
                    src="/img/eco_logo.png"
                    class="mb-4 d-block w-75"
                    style="margin: 0 auto"
                />
                <h1 class="h3 mb-3 font-weight-normal text-center">
                    Prosím prihláste sa
                </h1>

                <p
                    class="text-danger text-center"
                    v-if="authErrors.has('invalid_credentials')"
                    v-text="authErrors.get('invalid_credentials')"
                ></p>

                <label for="email" class="sr-only">Email</label>
                <input
                    type="email"
                    id="email"
                    name="email"
                    value=""
                    required="required"
                    autofocus="autofocus"
                    class="form-control"
                    v-model="email"
                    placeholder="Email address"
                />

                <label for="password" class="sr-only">Heslo</label>
                <input
                    type="password"
                    class="form-control"
                    placeholder="Password"
                    id="password"
                    name="password"
                    required="required"
                    v-model="password"
                />
                <div class="checkbox mb-3">
                    <label>
                        <input
                            type="checkbox"
                            name="rememberme"
                            v-model="remember"
                        />
                        Zapamätať prihlásenie
                    </label>
                </div>
                <button class="btn btn-lg btn-primary btn-block" type="submit">
                    Prihlásiť
                </button>
            </form>
        </div>
    </div>
</template>

<style scoped>
html,
body {
    height: 100%;
}

nav {
    display: none !important;
}
body {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-align: center;
    -ms-flex-pack: center;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    padding-top: 40px;
    padding-bottom: 40px;
    background-color: #f5f5f5;
}

.form-signin {
    width: 100%;
    max-width: 330px;
    padding: 15px;
    margin: 0 auto;
}
.form-signin .checkbox {
    font-weight: 400;
}
.form-signin .form-control {
    position: relative;
    box-sizing: border-box;
    height: auto;
    padding: 10px;
    font-size: 16px;
}
.form-signin .form-control:focus {
    z-index: 2;
}
.form-signin input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
    margin-bottom: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
</style>
<script>
// import LayoutDefault from "@/layouts/LayoutDefault.vue";

export default {
    name: "Login",

    // created() {
    //     this.$emit(`update:layout`, LayoutDefault);
    // },

    data() {
        return {
            email: "",
            password: "",
            remember: false
        };
    },
    computed: {
        authErrors() {
            if (this.$store.getters.authErrors.has("invalid_credentials")) {
                // this.$bvToast.toast(this.$store.getters.authErrors.get('invalid_credentials'), {
                //     title: 'Warning',
                //     variant: 'warning',
                //     solid: true
                // });
            }

            return this.$store.getters.authErrors;
        }
    },
    methods: {
        login: function() {
            const { email, password, remember } = this;
            this.$store
                .dispatch("authRequest", { email, password, remember })
                .then(() => {
                    this.$router.push({ name: "dashboard" });
                });
        }
    }
};
</script>
